package com.macrofocus.eflux.components.link

import deckgl.util.calculateZoomLevel
import kotlinx.browser.window
import mui.material.Button
import mui.material.Link
import mui.system.sx
import org.locationtech.jts.geom.Geometry
import react.FC
import react.Props
import web.cssom.None
import web.cssom.px

external interface GoogleMapLinkProps : Props {
    var geometry: Geometry?
    var margin : Double?
    var zoomLevel: Double?
}

val GoogleMapLink = FC<GoogleMapLinkProps> { props ->
    Link {
        sx {
            textTransform = None.none
            paddingTop = 0.px
            paddingBottom = 0.px
        }

        component = Button
        onClick = {
            val physicalGeometry = props.geometry
            if(physicalGeometry != null) {
                val envelope = physicalGeometry.envelopeInternal
                val zoom = props.zoomLevel ?: calculateZoomLevel(
                    envelope.minX,
                    envelope.minY,
                    envelope.maxX,
                    envelope.maxY,
                    window.innerWidth,
                    window.innerHeight,
                    props.margin ?: 0.05
                )
                val url = "https://www.google.com/maps/@${physicalGeometry.centroid.y},${physicalGeometry.centroid.x},${zoom}z"
                window.open(url, "_blank")
            }
        }

        +"Google Map"
    }
}
